(() => {
function $d7afcfeeffc74522$var$removeInlineStyles() {
    const elements = document.querySelectorAll(".author-block .author-socials-block-profile, .author-socials-block .author-socials-block-profile, .comments-block .author-socials-block-profile, .single-comment .gb-profile-name");
    elements.forEach(function(element) {
        element.removeAttribute("style");
    });
}
function $d7afcfeeffc74522$var$enablePollAutoSubmit() {
    const pollOptions = document.querySelectorAll(".dilemma-radio input[type='radio'], .agree-disagree-radio input[type='radio']");
    pollOptions.forEach(function(option) {
        option.addEventListener("change", function() {
            this.closest("form").submit();
        });
    });
}
function $d7afcfeeffc74522$var$initCustomScripts() {
    $d7afcfeeffc74522$var$removeInlineStyles();
    $d7afcfeeffc74522$var$enablePollAutoSubmit();
}
jQuery(document).ready(function($) {
    $(".gfield_radio .gfield-choice-input").on("change", function() {
        // Remove active class from all choices
        $(".gchoice").removeClass("selected-choice");
        $(".gfield-choice-input").removeClass("selected-input");
        // Add class to the selected input and its wrapper div
        $(this).addClass("selected-input");
        $(this).closest(".gchoice").addClass("selected-choice");
    });
});
document.addEventListener("DOMContentLoaded", ()=>{
    // Initial run if needed
    $d7afcfeeffc74522$var$initCustomScripts();
    const targetNode = document.querySelector(".cs-nextpost-inner");
    const config = {
        attributes: false,
        childList: true,
        subtree: false
    };
    const callback = (mutationList, observer)=>{
        for (const mutation of mutationList)if (mutation.type === "childList" && mutation.addedNodes.length > 0) mutation.addedNodes.forEach((node)=>{
            if (node.nodeType === 1 && node.classList.contains("cs-nextpost-section")) {
                // Run your logic on this newly added post section
                $d7afcfeeffc74522$var$injectAdsElement(node);
                $d7afcfeeffc74522$var$injectDPGAds(node);
                $d7afcfeeffc74522$var$initCustomScripts();
                console.log("Script Refresh + Ads Injected");
            }
        });
    };
    const observer = new MutationObserver(callback);
    if (targetNode) observer.observe(targetNode, config);
});
(function() {
    const select = document.getElementById("author_of_post");
    if (!select) return;
    select.addEventListener("change", function() {
        const selectedAuthorId = select.value;
        wp.data.dispatch("core/editor").editPost({
            meta: {
                author_of_post: selectedAuthorId
            }
        });
        const block = wp.data.select("core/block-editor").getSelectedBlock();
        if (block && block.name === "terrablock/author") wp.data.dispatch("core/block-editor").updateBlockAttributes(block.clientId, {
            selectedPostAuthorId: selectedAuthorId
        });
    });
    wp.data.subscribe(function() {
        const block = wp.data.select("core/block-editor").getSelectedBlock();
        if (block && block.name === "terrablock/author") {
            const selectedPostAuthorId = block.attributes.selectedPostAuthorId;
            if (selectedPostAuthorId === "" && select.value !== "") select.value = "";
            else if (selectedPostAuthorId !== select.value) select.value = selectedPostAuthorId;
        }
    });
})();
document.addEventListener("DOMContentLoaded", function() {
    let previousPage = document.referrer;
    console.log(previousPage);
    if (previousPage) {
        let link = document.querySelector(".wpb-previous-page-link a");
        if (link) link.setAttribute("href", previousPage);
    }
});
function $d7afcfeeffc74522$var$injectAdsElement(wrapper) {
    // clone of injectAds but directly for a wrapper element
    function createAdElement(scriptSrc) {
        let adDiv = document.createElement("div");
        adDiv.classList.add("ad-container");
        let separator = document.createElement("div");
        separator.classList.add("ad-separator");
        separator.innerHTML = "<span>Lees verder onder de advertentie</span>";
        let adScript = document.createElement("script");
        adScript.setAttribute("data-wid", "auto");
        adScript.type = "text/javascript";
        adScript.src = scriptSrc;
        adDiv.appendChild(separator);
        adDiv.appendChild(adScript);
        return adDiv;
    }
    let innerContainer = wrapper.querySelector(".wp-block-group__inner-container");
    if (innerContainer) {
        let p = Array.from(innerContainer.children).filter((el)=>el.tagName.toLowerCase() === "p");
        let divs = Array.from(innerContainer.children).filter((el)=>el.tagName.toLowerCase() === "div");
        if (divs.length >= 7) {
            divs[4].insertAdjacentElement("afterend", createAdElement("https://content.viralize.tv/display/?zid=AAEMbU6srPhvJIYz"));
            divs[5].insertAdjacentElement("afterend", createAdElement("https://content.viralize.tv/display/?zid=AAEMaGDGwI7K9GOx"));
        }
    }
}
function $d7afcfeeffc74522$var$injectDPGAds(wrapper) {
    function createAdElement(adId) {
        let adDiv = document.createElement("div");
        adDiv.classList.add("ad-container");
        let adScript = document.createElement("script");
        adScript.type = "text/javascript";
        adScript.innerHTML = `window.loadAdvertSlot("${adId}");`;
        adDiv.setAttribute("data-ad", "dpg");
        adDiv.setAttribute("id", adId);
        adDiv.appendChild(adScript);
        return adDiv;
    }
    let innerContainer = wrapper.querySelector(".wp-block-group__inner-container");
    if (!innerContainer) return;
    // Insert 'h1' ad at the beginning
    innerContainer.insertAdjacentElement("afterbegin", createAdElement("h1"));
    // Get only direct div children
    let divs = Array.from(innerContainer.children).filter((el)=>el.tagName.toLowerCase() === "div");
    // Insert after the 5th and 9th divs
    let p = Array.from(innerContainer.children).filter((el)=>el.tagName.toLowerCase() === "p");
    if (p[0]) p[0].insertAdjacentElement("afterend", createAdElement("c1"));
    if (divs.length >= 11) divs[9].insertAdjacentElement("afterend", createAdElement("c2"));
}

})();
//# sourceMappingURL=wpb-gutenberg.js.map
